import { useNavigate, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { ExternalToast, toast } from "sonner";

export type SonnerToastTypes = keyof typeof toast;
export type ToastType = Exclude<
    SonnerToastTypes,
    "getHistory" | "getToasts" | "custom" | "promise" | "loading" | "dismiss"
>;

export type ToastPayload = {
    type?: ToastType;
    message?: (() => React.ReactNode) | React.ReactNode;
    data?: ExternalToast;
};

export function RouterToast() {
    const navigate = useNavigate();
    const flash = useRouterState({
        select: (s) => s.location.state?.toast,
    });

    useEffect(() => {
        if (!flash) {
            return;
        }

        const handleToast = () => {
            if (!flash) {
                return;
            }

            if (!flash.type) {
                toast(flash.message || "", flash.data);
                return;
            }

            const stateToast = toast[flash.type];

            if (!stateToast) {
                toast(flash.message || "", flash.data);
                return;
            }

            stateToast(flash.message || "", flash.data);
        };

        handleToast();

        navigate({
            replace: true,
            state: (old) => {
                if (!old) {
                    return old;
                }

                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { toast: _toast, ...rest } = old;

                return rest;
            },
        });
    }, [flash, navigate]);

    return null;
}
